import Vue from "vue";
import {MarketingRepo, AccountsRepo, IdentityRepo} from '@core/repositories'
import Axios from 'axios'
import config from '@core/config/app.config.js'
import store from '@/store'
import {refreshToken } from '@core/config/utils'
const resource = '/users'
const identityResource = `session/preferences`

export default {  
    getRoles (config, uid) {
        uid = uid || store.getters['auth/account.current'].uid
        return AccountsRepo.get(`/accounts/${uid}/members/roles.json`, config)
    },
    getAccountList (config) {
        return MarketingRepo.get(`${resource}/account_list.json`, config)
    },
    getSelectedUsers (config) {
        return MarketingRepo.get(`${resource}.json`, config)
    },
    toggleFolder (config) {
        return MarketingRepo.get(`${resource}/toggle_folders.json`, config)
    },
    getAccountInfo(config){
        return MarketingRepo.get(`show.json`, config)
    },
    getPackageFeatures (config) {
        return MarketingRepo.get('/package_features.json', config)
    },
    getChannelSignature (config) {
        return MarketingRepo.get('/channel_signature.json', config)
    },
    getAllAccountList (config) {
        return AccountsRepo.get(`accounts.json`, config)
    },
    async getPreferences (config) {
        await refreshToken();
        let preferences = await Vue.prototype.$keycloak.loadUserProfile();
        if(preferences.attributes && preferences.attributes.preferences && preferences.attributes.preferences[0]){
            return JSON.parse(preferences.attributes.preferences[0])
        }
    },
    async getInfo(params) {
        const LoginAxios = Axios.create();
        const keycloak = Vue.prototype.$keycloak;
        await refreshToken();
        let timeZone = store.state.auth ? store.state.auth.preferences ? store.state.auth.preferences.time_zone : store.state.auth.preferences.time_zone : 'America/New_York';
        return LoginAxios.get(`${resource}/info.json`, {
          baseURL: `${config.RAILS_BASE_URL}/v2`,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "MP-ID-TOKEN": 'Bearer ' + keycloak.token,
            "Authorization": 'Bearer ' + keycloak.token,
            "TZ" : timeZone
          },
          withCredentials: true
        });
    },
    getUserDetail(UID) {
        return MarketingRepo.get(`${resource}/${UID}/detail.json`)
    },
    getTimezones (config) {
        return IdentityRepo.get(`/api/v1/time_zones`, config)
    },
}
